import React from 'react';
import styled from 'styled-components';

const AuthorCardContainer = styled.div`
    margin-top: 3rem;
    padding: 2rem 0;
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-left: 0;

    @media (max-width: 768px) {
        flex-direction: column;
        text-align: center;
        padding: 1.5rem 0;
        gap: 1rem;
        margin-left: 0;
    }
`;

const AuthorAvatar = styled.div`
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: linear-gradient(135deg, #4a5568 0%, #2d3748 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 2rem;
    font-weight: bold;
    flex-shrink: 0;

    @media (max-width: 768px) {
        width: 70px;
        height: 70px;
        font-size: 1.8rem;
    }
`;

const AuthorInfo = styled.div`
    flex: 1;

    h4 {
        margin: 0 0 0.5rem 0;
        font-size: 1.4rem;
        color: ${props => props.theme.body.headers};
        font-weight: 600;
    }

    .title {
        margin: 0 0 0.8rem 0;
        font-size: 1rem;
        color: ${props => props.theme.body.text};
        font-weight: 500;
        font-style: italic;
        opacity: 0.7;
    }

    .bio {
        margin: 0;
        font-size: 0.95rem;
        color: ${props => props.theme.body.text};
        line-height: 1.6;
        opacity: 0.8;
    }

    @media (max-width: 768px) {
        h4 {
            font-size: 1.2rem;
        }
        
        .title {
            font-size: 0.9rem;
        }
        
        .bio {
            font-size: 0.9rem;
        }
    }
`;

const AuthorCard = () => {
    return (
        <AuthorCardContainer>
            <AuthorAvatar>
                AC
            </AuthorAvatar>
            <AuthorInfo>
                <h4>Anthony Cazares</h4>
                <p className="title">Filósofo</p>
                <p className="bio">
                    Dedicado al estudio y reflexión de las grandes preguntas filosóficas que han acompañado a la humanidad a lo largo de la historia. 
                    Especializado en explorar temas como la naturaleza del ser, la ética, la estética y el conocimiento.
                </p>
            </AuthorInfo>
        </AuthorCardContainer>
    );
};

export default AuthorCard;